
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/tag/[tag]",
      function () {
        return require("private-next-pages/community/tag/[tag].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/tag/[tag]"])
      });
    }
  